<div class="relative flex w-full shadow-md shadow-slate-500 rounded-md overflow-hidden">

    <!-- Estado y fecha -->
    <div class="flex flex-col items-center justify-center gap-5 py-3 text-white px-10 w-[38%] max-w-[244px] shrink-0 bg-gray-400"
        [ngClass]="{'bg-pet-color-blue-1':consulta.estadoId === 1 || consulta.consultaEstadoCita===1,
                'bg-pet-green-1':consulta.estadoId === 2 || consulta.consultaEstadoCita===2,
                'bg-pet-color-blue-2':consulta.estadoId === 3 || consulta.consultaEstadoCita===3,
                'bg-pet-color-danger-1':consulta.estadoId === 4 || consulta.consultaEstadoCita===4}">
        <div class="border border-white py-2 px-3 rounded-md text-center">
            {{estadoConsulta[consulta.consultaEstadoCita]}}
            {{estadoConsulta[consulta.estadoId]}}
        </div>
        <div class="text-center">
            {{ consulta.consultaFechaCita| date:'EEEE' }}
            {{ consulta.consultaFechaCita| date:'dd/MM/yy':'medium' }}  <br>
            {{consulta.consultaHoraCita}}
            <ng-container *ngIf="( (consulta.estadoId === 7 || consulta.consultaEstadoCita === 7) && validacionVet == true )">
                Reagendada para:
                {{ consulta.consultaFechaReagendar| date:'EEEE' }}
                {{ consulta.consultaFechaReagendar| date:'dd/MM/yy':'medium' }}<br>
                {{consulta.consultaHoraReagendar}}
            </ng-container>
        </div>
    </div>

    <!-- Detalle -->
    <div class="flex flex-col flex-1 min-w-0 text-sm justify-center bg-pet-gray-1 py-2 pl-3 pr-10">
        <div class="flex text-sm text-gray-700 items-center gap-1"><mat-icon
                class="text-lg text-pet-color-6">person</mat-icon>Cliente: {{consulta.nombreUsuario}}</div>
        <div class="flex text-sm text-gray-700 items-center gap-1"><mat-icon
                class="text-lg text-pet-color-6">schedule</mat-icon>Tiempo estimado:
            {{consulta.consultaTiempoEstimadoConsulta}}</div>
        <div class="flex text-sm text-gray-700 items-center gap-1"><mat-icon
                class="text-lg text-pet-color-6">list_alt</mat-icon>{{ consulta.atencionNombre}}</div>
        <div class="flex text-sm text-gray-700 items-center gap-1"><mat-icon
                class="text-lg text-pet-color-6">attach_money</mat-icon>Valor de la Consulta: $
            {{consulta.consultaCostoConsulta | number}}</div>
        <div class="flex text-sm text-gray-700 items-center gap-1"><mat-icon
                class="text-lg text-pet-color-6">credit_card</mat-icon>Suscripción: -- --</div>
        <div class="flex text-sm text-gray-700 items-center gap-1"><mat-icon
                class="text-lg text-pet-color-6">payments</mat-icon>Metodo de Pago: {{consulta.consultaMetodoPago === 1
            ? 'Pago en linea' : '-- --'}}</div>
    </div>

    <!-- Acciones -->
    <div class="absolute flex flex-col top-1 right-1">

        <!-- PAGAR -->
        <ng-container *ngIf="(consulta.estadoId === 3 || consulta.consultaEstadoCita===3
            && validacionCli == true);">
            <button type="button" (click)="confirmPayment()"
                class="flex items-center justify-center w-6 h-6 rounded-full text-pet-color-text-1 hover:text-pet-color-5">
                <mat-icon matTooltip="Pagar Cita" [matTooltipPosition]="'right'" class="material-icons-outlined">check_circle</mat-icon>
            </button>
        </ng-container>

        <!-- CONFIRMAR -->
        <ng-container *ngIf="(
            (consulta.estadoId === 1 || consulta.consultaEstadoCita === 1)
            && validacionVet == true
        );">
            <button type="button" (click)="confirm()"
                class="flex items-center justify-center w-6 h-6 rounded-full text-pet-color-text-1 hover:text-pet-color-5">
                <mat-icon matTooltip="Aceptar Cita" [matTooltipPosition]="'right'" class="material-icons-outlined">check_circle</mat-icon>
            </button>
        </ng-container>

        <!-- CANCELAR -->
        <ng-container *ngIf="(consulta.estadoId === 1 || consulta.consultaEstadoCita=== 1  ||
            consulta.estadoId === 3 || consulta.consultaEstadoCita===3
        );">
            <button type="button" (click)="cancel()"
                class="flex items-center justify-center w-6 h-6 rounded-full text-pet-color-text-1 hover:text-pet-color-5">
                <mat-icon matTooltip="Cancelar Cita" [matTooltipPosition]="'right'" class="material-icons-outlined">cancel</mat-icon>
            </button>
        </ng-container>

        <!-- SOLICITAR REAGENDAR -->
        <ng-container *ngIf="(
            consulta.estadoId === 2 || consulta.consultaEstadoCita === 2
            && validacionCli == true
            && fechaCita > now 
            && consulta.consultaReagendar == false)">
            <button type="button" (click)="solicitarReagendar()"
                class="flex items-center justify-center w-6 h-6 rounded-full text-pet-color-text-1 hover:text-pet-color-5">
                <mat-icon matTooltip="Reprogramar Cita" [matTooltipPosition]="'right'" class="material-icons-outlined">event_repeat</mat-icon>
            </button>
        </ng-container>

        <!-- ACEPTAR / CANCELAR REAGENDAMIENTO -->
        <ng-container *ngIf="( (consulta.estadoId === 7 || consulta.consultaEstadoCita === 7)
            && validacionVet == true )">
            <button type="button" (click)="aceptarReagendamiento()"
                class="flex items-center justify-center w-6 h-6 rounded-full text-pet-color-text-1 hover:text-pet-color-5">
                <mat-icon matTooltip="Aceptar Reagendamiento" [matTooltipPosition]="'right'" class="material-icons-outlined">check_circle</mat-icon>
            </button>
            <button type="button" (click)="cancel()"
                class="flex items-center justify-center w-6 h-6 rounded-full text-pet-color-text-1 hover:text-pet-color-5">
                <mat-icon matTooltip="Cancelar Reagendamiento" [matTooltipPosition]="'right'" class="material-icons-outlined">cancel</mat-icon>
            </button>
        </ng-container>

    </div>

</div>